export function thumbFile(filename: string) {
  if (!filename) return null;
  let parts = filename.split('.');
  let ext = '';
  if (parts.length > 1) {
    ext = '.' + parts.pop();
    filename = filename.substr(0, filename.length - ext.length);
    ext = ext.toLowerCase();
  }

  

  return `__${filename}${ext}`;
}
